import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  RecordPicker,
  selectUser,
  UserState,
} from 'gossamer-front-end';
import { AllBookSingleEventRequest, BookingExtendedView, BookingView, Event } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';
import { CustomInfo } from 'cb-unified';

export interface BookMemberToEventButtonProps {
  userId: string;
}

export const BookUserToEventButton: React.FC<BookMemberToEventButtonProps> = (props) => {
  const [eventId, setEventId] = React.useState<string | null>(null);
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const today = new Date().toISOString().substring(0, 10);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const eventConditions = [getFilter('start_at', 'gt', today, 'hidden'), getFilter('title', 'sw', '')];
  if (user.roleId !== 'staff') {
    eventConditions.push(
      getFilter('institution_id', 'eq', (user.customInfo as CustomInfo)?.adminInstitutionId, 'hidden'),
    );
  }

  const handleClick = async () => {
    try {
      const payload: AllBookSingleEventRequest = {
        userId: props.userId,
        eventId: parseInt(eventId),
      };
      const response = await fetchApi('POST', `/main/book-user-to-event`, payload);
      resetCache(BookingView.id);
      resetCache(BookingExtendedView.id);
      setEventId(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while booking the member to the event');
    }
  };
  return (
    <InputGroup>
      <InputGroup.Text>Book this Member to an Event</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setEventId}
        value={eventId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Event',
          refEntity: Event,
        }}
        queryOptions={{
          where: {
            and: eventConditions,
          },
          order: [['start_at', 'ASC']],
        }}
      />
      <Button size="sm" variant="primary" disabled={!eventId} onClick={handleClick}>
        Book
      </Button>
    </InputGroup>
  );
};
